import { render, staticRenderFns } from "./WebupDetail.vue?vue&type=template&id=53cb29d9&scoped=true&"
import script from "./WebupDetail.vue?vue&type=script&lang=ts&"
export * from "./WebupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WebupDetail.vue?vue&type=style&index=0&id=53cb29d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb29d9",
  null
  
)

export default component.exports